import TokenHandlerClient from '../utils/client/TokenHandlerClient';

export const loginCode = (body: any) => {
    return TokenHandlerClient.post('/code', { ...body });
};

export const loginMobileConnect = (body: any) => {
    return TokenHandlerClient.post('/mc', { ...body });
};

export const loginSSO = (body: any) => {
    return TokenHandlerClient.post('/sso', { ...body });
};

export const generateJwe = () => {
    return TokenHandlerClient.post('/jwe', {
        source: 'APPSEC',
        destination: 'SSOPAR',
    });
};

export const logout = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    return TokenHandlerClient.post('/logout');
};
